import { STEP_VALIDATORS } from '@eduzz-registry-360/validators';

import { authStore } from '@/stores/auth';

import { ANONYMOUS_USER_ID } from './constants';
import { toCanonicalStepName } from './map';

const completedStepsByUser = new Map<string, Set<string>>();

export const resolveTrackingUserId = () => authStore.getState().currentUser?.id ?? ANONYMOUS_USER_ID;

const getOrCreateCompletedSteps = (userId: string) => {
  let steps = completedStepsByUser.get(userId);

  if (!steps) {
    steps = new Set<string>();
    completedStepsByUser.set(userId, steps);
  }

  return steps;
};

export const seedCompletedSteps = (registry: Record<string, unknown>) => {
  const userId = resolveTrackingUserId();

  if (completedStepsByUser.has(userId)) {
    return;
  }

  const completed = new Set<string>();

  for (const [name, validator] of Object.entries(STEP_VALIDATORS)) {
    if (validator.safeParse(registry).success) {
      completed.add(toCanonicalStepName(name));
    }
  }

  completedStepsByUser.set(userId, completed);
};

export const hasCompletedStep = (canonicalStepName: string) => {
  const steps = completedStepsByUser.get(resolveTrackingUserId());
  return steps?.has(canonicalStepName) ?? false;
};

export const markCompletedStep = (canonicalStepName: string) => {
  getOrCreateCompletedSteps(resolveTrackingUserId()).add(canonicalStepName);
};
